export const OnlyMonthFormat = "MM/YYYY";
export const CalendarDateFormat = "YYYY-MM-DD";
export const DisabledClickClassName = "fc-day-disabled";
export const OrdersCalendarRoutes = {
    YEARLY_VIEW: "/dashboard/orders-calendar/yearly/view",
    YEARLY_SUMMARY: "/dashboard/orders-calendar/yearly/summary",
    ORDERS_CALENDAR: "/dashboard/orders-calendar"
};
